import React from 'react'
import { Grid, Icon, InputBase, makeStyles } from '@material-ui/core';
import useSearchBar from './useSearchBar'
import { blueGrey } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
    root:{
        background:'white',
        boxShadow:'0 10px 24px 0 rgba(82, 91, 115, .12)',
        padding:'8px 16px',
        borderRadius:32,
    },
    icon:{
        color:blueGrey[500],

    }
}))

const SearchBar = props => {

    const classes = useStyles()

    const { onUpdateTableFilter, tableFilter, onChange, value} = props
    const {inputRef, actions} = useSearchBar({ onUpdateTableFilter, tableFilter, onChange })


    return(
        <div className={classes.root}>
            {/* <Grid container alignItems='center' spacing={1}> 
                <Grid item xs>
                    <InputBase value={search} placeholder='Buscar...' onChange={actions.onUpdateSearchValue} 
                        onKeyUp={actions.onStartCountDown} onKeyDown={actions.onStopCountDown} 
                        ref={inputRef} style={{ width:'100%'}} />
                </Grid>
                <Grid item>
                    <Icon className={classes.icon} fontSize='default'>search</Icon>
                </Grid>
            </Grid> */}
            <Grid container alignItems='center' spacing={1} wrap='nowrap'>
                <Grid item>
                    <Icon className={classes.icon} fontSize='default'>search</Icon>
                </Grid>
                <Grid item>
                    <InputBase value={value} placeholder='Buscar...' onChange={actions.onUpdateSearchValue} 
                        onKeyUp={actions.onStartCountDown} onKeyDown={actions.onStopCountDown} 
                        ref={inputRef} />
                </Grid>
            </Grid>
        </div>
    )
}

export default SearchBar